export const toSnakeCase = (str: string): string => {
  // Handle camelCase to snake_case conversion
  let result = str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)

  // Also handle cases where we have lowercase letters followed by numbers (like address1 -> address_1)
  result = result.replace(/([a-z])(\d+)$/g, '$1_$2')

  return result
}

export const toCamelCase = (str: string): string => {
  return str.replace(/_([a-z0-9])/g, (_, letter) => letter.toUpperCase())
}

export const transformKeysToSnake = <T extends Record<string, any>>(obj: T): Record<string, any> => {
  return Object.keys(obj).reduce((acc, key) => {
    const newKey = toSnakeCase(key)
    const value = obj[key]

    if (value && typeof value === 'object') {
      if (Array.isArray(value)) {
        // Handle arrays - transform each object in the array
        acc[newKey] = value.map(item =>
          item && typeof item === 'object' ? transformKeysToSnake(item) : item
        )
      } else {
        // Handle nested objects
        acc[newKey] = transformKeysToSnake(value)
      }
    } else {
      acc[newKey] = value
    }

    return acc
  }, {} as Record<string, any>)
}

export const transformKeysToCamel = <T extends Record<string, any>>(obj: T): Record<string, any> => {
  return Object.keys(obj).reduce((acc, key) => {
    const newKey = toCamelCase(key)
    const value = obj[key]

    if (value && typeof value === 'object') {
      if (Array.isArray(value)) {
        // Handle arrays - transform each object in the array
        acc[newKey] = value.map(item =>
          item && typeof item === 'object' ? transformKeysToCamel(item) : item
        )
      } else {
        // Handle nested objects
        acc[newKey] = transformKeysToCamel(value)
      }
    } else {
      acc[newKey] = value
    }

    return acc
  }, {} as Record<string, any>)
}
